<template>
  <div id="training-set-image-classification">
    <div class="container">

      <Panel title="Analyse du système de recommandations">
        <div style="display: flex; align-items: center">
          <div style="width: 100px">Branche</div>
          <select style="width: 400px" v-model="selectedBranch">
            <option v-for="branch in branches" :value="branch.id">{{ branch.name }}</option>
          </select>
        </div>

        <div style="display: flex; align-items: center">
          <div style="width: 100px">Compagnie</div>
          <select style="width: 400px" v-model="selectedCompany">
            <option v-for="company in companies" :value="company.id">{{ company.name }}</option>
          </select>
        </div>

        <div style="display: flex; align-items: center">
          <div style="min-width: 100px">Utilisateur</div>
          <input style="width: 300px" v-model="analysisData.user.username" type="text" readonly>
          <button style="width: 100px" class="btn btn-primary" @click="fetchNextUser" :disabled="!selectedCompany">
            Prochain
          </button>
        </div>

        <div style="display: flex; margin-top: 50px">
          <div style="flex-grow: 1; flex-basis: 0">
            <span><b>Historique</b></span>
            <div v-for="h in analysisData.history.perClass">{{ formatQty(h.qty) }} x {{ h.name }}</div>
          </div>
          <div style="flex-grow: 1; flex-basis: 0">
            <span><b>MF</b></span>
            <div v-for="h in analysisData.mf.class">{{ h.name }}</div>
          </div>
          <div style="flex-grow: 1; flex-basis: 0">
            <span><b>Surprise</b></span>
            <div v-for="h in analysisData.surprise.class">{{ h.name }} ({{ h.est.toFixed(2) }})</div>
          </div>
        </div>

        <div style="display: flex; margin-top: 50px">
          <div style="flex-grow: 1; flex-basis: 0">
            <span><b>Historique</b></span>
            <div v-for="h in analysisData.history.perItem">{{ formatQty(h.qty) }} x {{ h.name }}</div>
          </div>
          <div style="flex-grow: 1; flex-basis: 0">
            <span><b>MF</b></span>
            <div v-for="h in analysisData.mf.item">{{ h.name }}</div>
          </div>
          <div style="flex-grow: 1; flex-basis: 0">
            <span><b>Surprise</b></span>
            <div v-for="h in analysisData.surprise.item">{{ h.name }} ({{ h.est.toFixed(2) }})</div>
          </div>
        </div>
      </Panel>

    </div>
  </div>
</template>

<script>
  import { Core } from '@/core/Core';

  export default {
    name: "RecommenderAnalysis",

    data() {
      return {
        branches: [],
        companies: [],
        userOffset: 0,
        selectedBranch: null,
        selectedCompany: null,
        analysisData: {}
      }
    },

    mounted() {
      this.resetData();
      this.$store.commit("showSpinner", true);
      Core.request("GET", '/api/entity/branch/select')
        .then(branches => {
          this.branches = branches
        })
        .catch(e => {
          toast(this.$t("error.no_server"), "error");
        })
        .finally(() => {
          this.$store.commit("showSpinner", false)
        });
    },

    methods: {
      fetchNextUser: function () {
        this.$store.commit("showSpinner", true);
        Core.request("GET", '/api/recommender/analysis', {
          company: this.selectedCompany,
          branch: this.selectedBranch,
          user_offset: this.userOffset
        }).then(data => {
          this.analysisData = data;
          this.userOffset++
        }).catch(e => {
          toast(this.$t("error.no_server"), "error");
        }).finally(() => {
          this.$store.commit("showSpinner", false)
        })
      },

      resetData: function () {
        this.userOffset = 0;
        this.analysisData = {
          history: {
            nbSales: null,
            perClass: [],
            perItem: []
          },
          mf: {
            class: [],
            item: []
          },
          surprise: {
            class: [],
            item: []
          },
          user: {
            username: null
          }
        };
      },

      formatQty: function (qty) {
        return parseInt(qty)
      }
    },

    watch: {
      selectedBranch: function (branchId) {
        this.resetData();
        this.$store.commit("showSpinner", true);
        Core.request("GET", '/api/entity/company/select', { branch: branchId })
          .then(companies => {
            this.companies = companies;
          })
          .catch(e => {
            toast(this.$t("error.no_server"), "error");
          })
          .finally(() => {
            this.$store.commit("showSpinner", false)
          })
      },

      selectedCompany: function () {
        this.resetData();
        this.fetchNextUser()
      }
    }
  }
</script>